import React, { useEffect } from "react";
import "./SobreNosotros.css";
import "./SobreNosotros2.css";

import oxanalogo from "./images/oxana-logo.webp";
import perrylogo from "./images/perry-logo.webp";

const SobreNosotros = (props) => {
  const [isVisible, setIsVisible] = React.useState(props.isVisible);

  useEffect(() => {
    setIsVisible(props.isVisible);
  }, [props.isVisible]);

  const handleClose = () => {
    props.onClose();
    setIsVisible(false);
  };

  return (
    <div
      className={`sobre-nosotros-container ${
        isVisible ? "sobre-nosotros-visible" : "sobre-nosotros-hidden"
      }`}
    >
      <div className="contenedor">
        <div className="seccion1">
          <img src={oxanalogo} className="aboutlogos1" />
          <div>
            <hr
              style={{
                height: "2px",
                borderWidth: "0",
                color: "gray",
                backgroundColor: "#cdd8e5",
                marginTop: "10px",
                marginBottom: "20px",
              }}
            />
            <h1>OXANA OHB SL</h1>
            <hr
              style={{
                height: "2px",
                borderWidth: "0",
                color: "gray",
                backgroundColor: "#cdd8e5",
                marginTop: "10px",
                marginBottom: "20px",
              }}
            />
            En <strong>OXANA OHB SL</strong>, nos especializamos en{" "}
            <strong>Medicina Hiperbárica</strong> y somos distribuidores
            exclusivos de{" "}
            <a
              href="http://www.perrybaromedical.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <strong>PERRY BAROMEDICAL</strong>
            </a>
            , una marca de renombre internacional por la alta calidad de sus
            cámaras hiperbáricas monoplaza. Más información en{" "}
            <a
              href="http://www.perrybaromedical.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <strong>www.perrybaromedical.com</strong>
            </a>
            .
          </div>

          <div>
            <p>
              Desde hace casi 15 años, nos hemos dedicado a la distribución
              especializada de cámaras hiperbáricas, continuando la labor de la
              antigua{" "}
              <span className="nowrap">
                <strong>OXIGENARTE INT SL</strong>
              </span>{" "}
              bajo el nombre de <strong>OXANA OHB SL</strong>.
            </p>

            <p>
              Nos enorgullecemos de trabajar exclusivamente con cámaras
              hiperbáricas de alta calidad de <strong>PERRY BAROMEDICAL</strong>
              . Estas cámaras están diseñadas para cumplir con los más altos
              estándares de la Medicina Hiperbárica, incluyendo:
            </p>

            <ul>
              <li>
                Suministro de 100% oxígeno durante toda la sesión gracias a un
                sistema de ventilación continua.
              </li>
              <li>Capacidad de presión de hasta 3 ATA.</li>
              <li>
                Incorporación de Rotura de Aire, que logra un equilibrio entre
                Hipoxia y Hiperoxia.
              </li>
            </ul>
            <h3>Un Servicio Integral para la Medicina Hiperbárica</h3>
            <p>
              Adicionalmente, ofrecemos un servicio integral que incluye
              instalación, puesta en marcha y mantenimiento realizados por
              técnicos europeos y españoles. Mantenemos una colaboración cercana
              con el{" "}
              <strong>
                <a
                  href="http://www.iemh.es"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Instituto Español de Medicina Hiperbárica (IEMH.es)
                </a>
              </strong>
              , a través de la cual brindamos formación de alta calidad a los
              profesionales a cargo de estas unidades.
            </p>
            <p>
              Nuestra misión en{" "}
              <span className="nowrap">
                <strong>OXANA OHB SL</strong>
              </span>{" "}
              es acompañarle en cada etapa de su proyecto en Medicina
              Hiperbárica, brindando la calidad y seguridad que merece. Buscamos
              ser más que un proveedor; queremos ser su ¡SOCIO DE CONFIANZA!.
            </p>
          </div>
        </div>
        <div className="seccion2">
          <img src={perrylogo} className="aboutlogos2" />
          <div>
            <hr
              style={{
                height: "2px",
                borderWidth: "0",
                color: "gray",
                backgroundColor: "#cdd8e5",
                marginTop: "10px",
                marginBottom: "20px",
              }}
            />
            <h1>Perry Baromedical</h1>
            <hr
              style={{
                height: "2px",
                borderWidth: "0",
                color: "gray",
                backgroundColor: "#cdd8e5",
                marginTop: "10px",
                marginBottom: "20px",
              }}
            />
            <h3>¿Por Qué Elegir Cámaras Hiperbáricas de Perry Baromedical?</h3>

            <p>
              Perry Baromedical es un líder global en el diseño y fabricación de
              cámaras hiperbáricas de alta calidad, con más de 50 años de
              experiencia innovadora en el campo. Con presencia notoria en los
              Estados Unidos y una amplia expansión internacional, Perry ha
              instalado más de 1.200 unidades en hospitales y clínicas de
              renombre alrededor del mundo.
            </p>

            <p>Lo que distingue a Perry son sus múltiples innovaciones:</p>

            <ul>
              <li>
                Fue el primer fabricante en ofrecer cámaras monoplaza en tres
                tamaños distintos.
              </li>
              <li>
                Introdujo el cilindro de metacrilato más grande en el mercado,
                con la cámara monoplaza Sigma 40, marcando un hito en la
                medicina hiperbárica.
              </li>
              <li>
                Perry lideró al habilitar conexiones para la monitorización y
                administración de medicamentos dentro de la cámara, lo cual
                también facilita el Sistema de Air Break.
              </li>
              <li>
                Innovó en el diseño al elegir el color "blanco" para sus cámaras
                monoplaza, proyectando limpieza y calidez.
              </li>
              <li>
                Es el primer fabricante en ofrecer una cámara hiperbárica
                transparente para dos pacientes.
              </li>
              <li>
                Ha creado un sistema respiratorio único para apoyar estudios
                doble ciego.
              </li>
            </ul>

            <p>
              Su enfoque en calidad e integridad los coloca como un referente en
              la industria.
            </p>
            <div>
              Más información en{" "}
              <a
                href="http://www.perrybaromedical.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <strong>www.perrybaromedical.com</strong>
              </a>
              .
            </div>
            <br />
            <br />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SobreNosotros;
